import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './EditListingActionButton.css';
import { SecondaryButton, Button } from '../../components';
import { FormattedMessage } from 'react-intl';
import { BACK_SUBMIT_TYPE } from '../../util/types';
import { string } from 'prop-types';
import NamedLink from '../NamedLink/NamedLink';

const EditListingActionButton = props => {
  const {
    rootClassName,
    className,
    nextBtnClassName,
    backBtnClassName,
    nextBtnMessage,
    backBtnMessage,
    exitBtnClassName,
    form,
    invalid,
    onBackWithoutSubmit,
    submitInProgress,
    submitReady,
    submitDisabled,
  } = props;

  const [isBack, setIsBack] = useState(false);

  const classes = classNames(rootClassName || css.root, className);
  const nextButtonClasses = classNames(css.submitButton || nextBtnClassName);
  const backButtonClasses = classNames(css.submitButton, backBtnClassName);
  const exitButtonClasses = classNames(css.exitButton, exitBtnClassName);
  const backInProgess = isBack ? submitInProgress : false;
  const trueSubmitInProgress = !isBack ? submitInProgress : false;
  const backDisabled = submitInProgress || backInProgess;

  const onBackSubmit = () => {
    setIsBack(true);
    if (invalid) {
      onBackWithoutSubmit();
      return;
    }
    form.change('typeSubmit', BACK_SUBMIT_TYPE);
    form.change('isValid', !invalid);
    form.submit();
  };

  const defaultBackButtonMessage = (
    <FormattedMessage id="EditListingActionButton.backButtonMessage" />
  );
  const defaultNextButtonMessage = (
    <FormattedMessage id="EditListingActionButton.defaultNextButtonMessage" />
  );

  const defaultExitButtonMessage = (
    <FormattedMessage id="EditListingActionButton.defaultExitButtonMessage" />
  );

  return (
    <div className={classes}>
      <SecondaryButton
        className={backButtonClasses}
        type="button"
        inProgress={backInProgess}
        disabled={backDisabled}
        onClick={onBackSubmit}
      >
        {backBtnMessage || defaultBackButtonMessage}
      </SecondaryButton>

      <Button
        className={nextButtonClasses}
        type="submit"
        inProgress={trueSubmitInProgress}
        disabled={submitDisabled}
        ready={submitReady}
        onClick={() => {
          setIsBack(false);
        }}
      >
        {nextBtnMessage || defaultNextButtonMessage}
      </Button>

      <NamedLink
        className={exitButtonClasses}
        name="ManageListingsPage"
      >
        {defaultExitButtonMessage}
      </NamedLink>
    </div>
  );
};

EditListingActionButton.defaultProps = {
  submitInProgress: false,
  submitReady: false,
  submitDisabled: false,
};

const { bool, func, object } = PropTypes;

EditListingActionButton.propTypes = {
  rootClassName: string,
  className: string,
  nextBtnClassName: string,
  backBtnClassName: string,
  nextBtnMessage: string,
  backBtnMessage: string,
  form: object.isRequired,
  invalid: bool.isRequired,
  onBackWithoutSubmit: func.isRequired,
  submitInProgress: bool,
  submitReady: bool,
  submitDisabled: bool,
};

export default EditListingActionButton;
